import React from "react";
import noData from "../../assets/images/svg/noData.svg";

const EmptyPerformance = ({ customClass }) => {
  return (
    <div
      className={
        customClass === undefined
          ? "no_data_performance"
          : `no_data_performance ${customClass}`
      }
    >
      <img src={noData} alt="no_data" /> <h4>No Data Found</h4>
    </div>
  );
};

export default EmptyPerformance;
